import apiPdca from '../../../../helpers/apiPdca'
import {
  loading,
  loaded,
  modalAlertaInfo,
  modalAlertaClean
} from '../../../../layout/redux/layoutActions'

import {
  APROVARPLANOPLAN_FETCH_REQUEST,
  APROVARPLANOPLAN_FETCH_SUCCESS,
  APROVARPLANOPLAN_FETCH_FAILURE,
  APROVARPLANOPLAN_USERS_REQUEST,
  APROVARPLANOPLAN_USERS_SUCCESS,
  APROVARPLANOPLAN_USERS_FAILURE,
  APROVARPLANOPLAN_INTEGRACAO_REQUEST,
  APROVARPLANOPLAN_INTEGRACAO_SUCCESS,
  APROVARPLANOPLAN_INTEGRACAO_FAILURE,
  APROVARPLANOPLAN_BUSCAR_DESTINO_REQUEST,
  APROVARPLANOPLAN_BUSCAR_DESTINO_SUCCESS,
  APROVARPLANOPLAN_BUSCAR_DESTINO_FAILURE,
  APROVARPLANOPLAN_VALIDAR_URL_REQUEST,
  APROVARPLANOPLAN_VALIDAR_URL_SUCCESS,
  APROVARPLANOPLAN_VALIDAR_URL_FAILURE,
  APROVARPLANOPLAN_GRAVAR_DESTINO_REQUEST,
  APROVARPLANOPLAN_GRAVAR_DESTINO_SUCCESS,
  APROVARPLANOPLAN_GRAVAR_DESTINO_FAILURE,
  APROVARPLANOPLAN_SUBMIT_REQUEST,
  APROVARPLANOPLAN_SUBMIT_SUCCESS,
  APROVARPLANOPLAN_SUBMIT_FAILURE,
  APROVARPLANOPLAN_CLEAR
} from './aprovarplanoplanReducer'

import { AddAlert } from '../../../../components'

const abrirErroPadrao = (dispatch, nlsPopup) => {
  dispatch(
    modalAlertaInfo({
      ...nlsPopup[7],
      btnAction: () => dispatch(modalAlertaClean()),
      show: true
    })
  )
}

const construirEndpointsIntegracao = ferramentaCodigo => {
  switch (ferramentaCodigo) {
    case 'asana':
      return {
        buscarDestino: projetoId => `/projetos/${projetoId}/integracao/asana/destino`,
        validarDestino: projetoId => `/projetos/${projetoId}/integracao/asana/projetos/resolver`,
        gravarDestino: projetoId => `/projetos/${projetoId}/integracao/asana/destino`
      }

    case 'clickup':
      return {
        buscarDestino: projetoId => `/projetos/${projetoId}/integracao/clickup/destino`,
        validarDestino: projetoId => `/projetos/${projetoId}/integracao/clickup/destino/resolver`,
        gravarDestino: projetoId => `/projetos/${projetoId}/integracao/clickup/destino`
      }

    case 'jira':
      return {
        buscarDestino: projetoId => `/projetos/${projetoId}/integracao/jira/destino`,
        validarDestino: projetoId => `/projetos/${projetoId}/integracao/jira/projetos/resolver`,
        gravarDestino: projetoId => `/projetos/${projetoId}/integracao/jira/destino`
      }


    case 'trello':
      return {
        buscarDestino: projetoId => `/projetos/${projetoId}/integracao/trello/destino`,
        validarDestino: projetoId => `/projetos/${projetoId}/integracao/trello/destino/resolver`,
        gravarDestino: projetoId => `/projetos/${projetoId}/integracao/trello/destino`
      }


    case 'monday':
      return {
        buscarDestino: projetoId => `/projetos/${projetoId}/integracao/monday/destino`,
        validarDestino: projetoId => `/projetos/${projetoId}/integracao/monday/destino/resolver`,
        gravarDestino: projetoId => `/projetos/${projetoId}/integracao/monday/destino`
      }


    default:
      return null
  }
}

export const fetchAprovarPlanoPlan = planoId => {
  return async (dispatch, getState) => {
    const { sistema } = getState().layoutState
    const nlsPopup = require(`../../../../layout/nlsPopup/${sistema.idioma}.json`)

    dispatch({ type: APROVARPLANOPLAN_FETCH_REQUEST })
    dispatch(loading())

    try {
      const response = await apiPdca.get(`/pdca/planos/detalheplano?planoId=${planoId}`)
      const data = response?.data

      if (!data?.ok) {
        throw new Error('Erro ao carregar aprovação do plano.')
      }

      dispatch({
        type: APROVARPLANOPLAN_FETCH_SUCCESS,
        payload: data
      })
    } catch (error) {
      dispatch({
        type: APROVARPLANOPLAN_FETCH_FAILURE,
        payload: error?.message || 'Erro ao carregar aprovação do plano.'
      })

      abrirErroPadrao(dispatch, nlsPopup)
    } finally {
      dispatch(loaded())
    }
  }
}

export const fetchUsuariosProjetoPdca = projetoId => {
  return async (dispatch, getState) => {
    const { sistema } = getState().layoutState
    const nlsPopup = require(`../../../../layout/nlsPopup/${sistema.idioma}.json`)

    dispatch({ type: APROVARPLANOPLAN_USERS_REQUEST })

    try {
      const response = await apiPdca.get(`/pdca/listarusuariosprojetopdca?projetoid=${projetoId}`)
      const data = response?.data

      if (!data?.ok) {
        throw new Error('Erro ao carregar usuários do projeto.')
      }

      const usuarios = Array.isArray(data?.usuarios)
        ? data.usuarios.map(item => ({
            label: item?.nomecompleto || '',
            value: item?.id,
            raw: item
          }))
        : []

      dispatch({
        type: APROVARPLANOPLAN_USERS_SUCCESS,
        payload: usuarios
      })
    } catch (error) {
      dispatch({
        type: APROVARPLANOPLAN_USERS_FAILURE,
        payload: error?.message || 'Erro ao carregar usuários do projeto.'
      })

      abrirErroPadrao(dispatch, nlsPopup)
    }
  }
}

export const fetchIntegracaoProjeto = projetoId => {
  return async (dispatch, getState) => {
    const { sistema } = getState().layoutState
    const nlsPopup = require(`../../../../layout/nlsPopup/${sistema.idioma}.json`)

    dispatch({ type: APROVARPLANOPLAN_INTEGRACAO_REQUEST })

    try {
      const response = await apiPdca.get(`/projetos/${projetoId}/integracao`)
      const data = response?.data || {}

      dispatch({
        type: APROVARPLANOPLAN_INTEGRACAO_SUCCESS,
        payload: data
      })
    } catch (error) {
      dispatch({
        type: APROVARPLANOPLAN_INTEGRACAO_FAILURE,
        payload: error?.message || 'Erro ao consultar integração do projeto.'
      })

      abrirErroPadrao(dispatch, nlsPopup)
    }
  }
}

export const buscarDestinoIntegracao = ({ projetoId, ferramentaCodigo }) => {
  return async (dispatch, getState) => {
    const { sistema } = getState().layoutState
    const nls = require(`../nls/${sistema.idioma}.json`)

    dispatch({ type: APROVARPLANOPLAN_BUSCAR_DESTINO_REQUEST })

    try {
      const endpoints = construirEndpointsIntegracao(ferramentaCodigo)

      if (!endpoints?.buscarDestino) {
        throw new Error(`Ferramenta não suportada para busca de destino: ${ferramentaCodigo}`)
      }

      const response = await apiPdca.get(endpoints.buscarDestino(projetoId))
      const data = response?.data || null

      dispatch({
        type: APROVARPLANOPLAN_BUSCAR_DESTINO_SUCCESS,
        payload: data
      })

      //dispatch(AddAlert('success', nls.searchUrlSuccessMessage))
      /*
      const mensagemBusca = (
        (ferramentaCodigo === 'jira' || ferramentaCodigo === 'trello' || ferramentaCodigo === 'monday') &&
        data?.destino == null
      )
        ? nls.searchUrlNotFoundMessage
        : nls.searchUrlSuccessMessage

      dispatch(AddAlert('success', mensagemBusca))
      */
      const semConfiguracao =
        (ferramentaCodigo === 'asana' ||
          ferramentaCodigo === 'clickup' ||
          ferramentaCodigo === 'jira' ||
          ferramentaCodigo === 'trello' ||
          ferramentaCodigo === 'monday') &&
        data?.destino == null

      const mensagemBusca = semConfiguracao
        ? nls.searchUrlNotFoundMessage
        : nls.searchUrlSuccessMessage

      dispatch(AddAlert(semConfiguracao ? 'danger' : 'success', mensagemBusca))

      return data
    } catch (error) {
      dispatch({
        type: APROVARPLANOPLAN_BUSCAR_DESTINO_FAILURE,
        payload: error?.message || 'Erro ao buscar destino da ferramenta.'
      })

      const iderro = error?.response?.data?.iderro
      const mensagem = iderro === 900
        ? nls.integrationAssigneeNotFoundMessage
        : nls.genericIntegrationErrorMessage

      dispatch(AddAlert('danger', mensagem))

      return null
    }
  }
}

export const validarDestinoIntegracao = ({ projetoId, ferramentaCodigo, url }) => {
  return async (dispatch, getState) => {
    const { sistema } = getState().layoutState
    const nls = require(`../nls/${sistema.idioma}.json`)

    dispatch({ type: APROVARPLANOPLAN_VALIDAR_URL_REQUEST })

    try {
      const endpoints = construirEndpointsIntegracao(ferramentaCodigo)

      if (!endpoints?.validarDestino) {
        throw new Error(`Ferramenta não suportada para validação de destino: ${ferramentaCodigo}`)
      }

      const response = await apiPdca.post(endpoints.validarDestino(projetoId), {
        url
      })

      const data = response?.data || null

      dispatch({
        type: APROVARPLANOPLAN_VALIDAR_URL_SUCCESS,
        payload: data
      })

      if (ferramentaCodigo !== 'monday') {
        dispatch(AddAlert('success', nls.validateUrlSuccessMessage))
}

      return data
    } catch (error) {
      dispatch({
        type: APROVARPLANOPLAN_VALIDAR_URL_FAILURE,
        payload: error?.message || 'Erro ao validar URL da ferramenta.'
      })

      const iderro = error?.response?.data?.iderro
      const mensagem = iderro === 900
        ? nls.integrationAssigneeNotFoundMessage
        : nls.genericIntegrationErrorMessage

      dispatch(AddAlert('danger', mensagem))

      return null
    }
  }
}

//export const gravarDestinoIntegracao = ({ projetoId, ferramentaCodigo, urlDestino, issueTypeId = null, listId = null }) => {
export const gravarDestinoIntegracao = ({
  projetoId,
  ferramentaCodigo,
  urlDestino,
  issueTypeId = null,
  listId = null,
  mondayConfig = null
}) => {    
  return async (dispatch, getState) => {
    const { sistema } = getState().layoutState
    const nls = require(`../nls/${sistema.idioma}.json`)

    dispatch({ type: APROVARPLANOPLAN_GRAVAR_DESTINO_REQUEST })

    try {
      const endpoints = construirEndpointsIntegracao(ferramentaCodigo)

      if (!endpoints?.gravarDestino) {
        throw new Error(`Ferramenta não suportada para gravação de destino: ${ferramentaCodigo}`)
      }

      const body = {
        urlDestino
      }

      if (ferramentaCodigo === 'jira' && issueTypeId) {
        body.issueTypeId = issueTypeId
      }

      if (ferramentaCodigo === 'trello' && listId) {
        body.listId = listId
      }


      if (ferramentaCodigo === 'monday') {
        body.groupId = listId || null
        body.peopleColumnId = mondayConfig?.peopleColumnId || null
        body.dateColumnId = mondayConfig?.dateColumnId || null
        body.textNotasColumnId = mondayConfig?.textNotasColumnId || null
      }

      const response = await apiPdca.put(endpoints.gravarDestino(projetoId), body)

      const data = response?.data || null

      dispatch({
        type: APROVARPLANOPLAN_GRAVAR_DESTINO_SUCCESS,
        payload: data
      })

      dispatch(AddAlert('success', nls.saveUrlSuccessMessage))

      return data
    } catch (error) {
      dispatch({
        type: APROVARPLANOPLAN_GRAVAR_DESTINO_FAILURE,
        payload: error?.message || 'Erro ao gravar destino da ferramenta.'
      })

      const iderro = error?.response?.data?.iderro
      const mensagem = iderro === 900
        ? nls.integrationAssigneeNotFoundMessage
        : nls.genericIntegrationErrorMessage

      dispatch(AddAlert('danger', mensagem))

      return null
    }
  }
}


export const gravarAcoesBlacklist = ({
  projetoId,
  acaoId,
  planoId,
  motivo = ''
}) => {
  return async (dispatch, getState) => {
    const { sistema } = getState().layoutState
    const nls = require(`../nls/${sistema.idioma}.json`)

    try {
      const response = await apiPdca.post('/pdca/gravaracoesblacklist', {
        projetoid: projetoId,
        acoes: [
          {
            acaoid: acaoId,
            planoid: planoId,
            motivo
          }
        ]
      })

      const data = response?.data

      if (!data?.ok) {
        throw new Error('Erro gravando ação na blacklist.')
      }

      dispatch(AddAlert('success', nls.blacklistSuccessMessage))

      return { ok: true, data }
    } catch (error) {
      const iderro = error?.response?.data?.iderro

      dispatch(
        AddAlert(
          'danger',
          iderro === 867
            ? nls.blacklistAlreadyExistsMessage
            : iderro === 868
              ? nls.blacklistMinimumReachedMessage
              : nls.blacklistGenericErrorMessage
        )
      )

      return { ok: false }
    }
  }
}




export const submitAprovarPlanoPlan = payload => {
  return async (dispatch, getState) => {
    const { sistema } = getState().layoutState
    const nlsPopup = require(`../../../../layout/nlsPopup/${sistema.idioma}.json`)

    dispatch({ type: APROVARPLANOPLAN_SUBMIT_REQUEST })
    dispatch(loading())

    try {
      const response = await apiPdca.post('/pdca/aprovarplanoplan', payload)
      const data = response?.data

      if (response?.status !== 200) {
        throw new Error('Erro ao aprovar plano.')
      }

      dispatch({
        type: APROVARPLANOPLAN_SUBMIT_SUCCESS,
        payload: data
      })

      return { ok: true, data }
    } catch (error) {
      dispatch({
        type: APROVARPLANOPLAN_SUBMIT_FAILURE,
        payload: error?.message || 'Erro ao aprovar plano.'
      })

      const iderro = error?.response?.data?.iderro

      dispatch(
        modalAlertaInfo({
          ...(iderro === 900 ? nlsPopup[900] : nlsPopup[7]),
          btnAction: () => dispatch(modalAlertaClean()),
          show: true
        })
      )

      return { ok: false }
    } finally {
      dispatch(loaded())
    }
  }
}

export const submitAprovarPlanoPlanOLD = payload => {
  return async (dispatch, getState) => {
    const { sistema } = getState().layoutState
    const nlsPopup = require(`../../../../layout/nlsPopup/${sistema.idioma}.json`)

    dispatch({ type: APROVARPLANOPLAN_SUBMIT_REQUEST })
    dispatch(loading())

    try {
      const response = await apiPdca.post('/pdca/aprovarplanoplan', payload)
      const data = response?.data

      if (response?.status !== 200) {
        throw new Error('Erro ao aprovar plano.')
      }

      dispatch({
        type: APROVARPLANOPLAN_SUBMIT_SUCCESS,
        payload: data
      })

      return { ok: true, data }
    } catch (error) {
      dispatch({
        type: APROVARPLANOPLAN_SUBMIT_FAILURE,
        payload: error?.message || 'Erro ao aprovar plano.'
      })

      abrirErroPadrao(dispatch, nlsPopup)
      return { ok: false }
    } finally {
      dispatch(loaded())
    }
  }
}

export const clearAprovarPlanoPlan = () => {
  return {
    type: APROVARPLANOPLAN_CLEAR
  }
}